import { createContext } from '@shared/utils/createContext';
import type { CarouselContextProps } from './Carousel.types';

export const [CarouselProvider, useCarouselContext] = createContext<CarouselContextProps>({ name: 'CarouselProvider' });
